const PERSIAN_DIGITS = "۰۱۲۳۴۵۶۷۸۹";

function toPersianDigits(n) {
  return String(n ?? "").replace(/\d/g, (d) => PERSIAN_DIGITS[parseInt(d, 10)]);
}

export function pickLatestLastSeen(...isoStrings) {
  let best = null;
  let bestMs = -Infinity;
  for (const iso of isoStrings) {
    if (!iso) continue;
    const ms = new Date(iso).getTime();
    if (!Number.isNaN(ms) && ms > bestMs) {
      bestMs = ms;
      best = iso;
    }
  }
  return best;
}

export function formatLastSeenCompact(isoString) {
  if (!isoString) return "";
  const last = new Date(isoString);
  if (Number.isNaN(last.getTime())) return "";

  const now = new Date();
  const diffMs = now.getTime() - last.getTime();
  if (diffMs < 0) return "";

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMinutes < 1) return "لحظاتی پیش آنلاین بوده";
  if (diffMinutes < 60) return `${toPersianDigits(diffMinutes)} دقیقه پیش آنلاین بوده`;
  if (diffHours < 24) return `${toPersianDigits(diffHours)} ساعت پیش آنلاین بوده`;
  if (diffDays < 7) return `${toPersianDigits(diffDays)} روز پیش آنلاین بوده`;

  try {
    const formatter = new Intl.DateTimeFormat("fa-IR", {
      month: "2-digit",
      day: "2-digit",
    });
    return `آخرین بازدید ${formatter.format(last)}`;
  } catch {
    const m = String(last.getMonth() + 1).padStart(2, "0");
    const d = String(last.getDate()).padStart(2, "0");
    return `آخرین بازدید ${toPersianDigits(`${m}/${d}`)}`;
  }
}

export function formatLastSeen(isoString) {
  if (!isoString) return "";
  const last = new Date(isoString);
  if (Number.isNaN(last.getTime())) return "";

  const now = new Date();
  const diffMs = now.getTime() - last.getTime();
  if (diffMs < 0) return "";

  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMinutes < 1) {
    return "لحظاتی پیش آنلاین بود";
  }

  if (diffMinutes < 60) {
    return `آخرین بازدید ${toPersianDigits(diffMinutes)} دقیقه پیش`;
  }

  if (diffHours < 24) {
    return `آخرین بازدید ${toPersianDigits(diffHours)} ساعت پیش`;
  }

  if (diffDays < 7) {
    return `آخرین بازدید ${toPersianDigits(diffDays)} روز پیش`;
  }

  try {
    const formatter = new Intl.DateTimeFormat("fa-IR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const dateText = formatter.format(last);
    return `آخرین بازدید ${dateText}`;
  } catch {
    const y = last.getFullYear();
    const m = String(last.getMonth() + 1).padStart(2, "0");
    const d = String(last.getDate()).padStart(2, "0");
    return `آخرین بازدید ${toPersianDigits(`${y}/${m}/${d}`)}`;
  }
}

